// Cart count visibility: hide bubble when empty, show when populated.
(function() {
  let observer = null;

  function setupObserver() {
    const cartCountElement = document.querySelector('.header__cart-count cart-count.count-bubble');
    const headerCartCount = document.querySelector('.header__cart-count');

    if (cartCountElement && headerCartCount) {
      if (observer) observer.disconnect();

      function updateVisibility() {
        const countText = cartCountElement.textContent.trim();
        const count = parseInt(countText, 10);
        const shouldHide = count === 0 || isNaN(count);
        headerCartCount.style.visibility = shouldHide ? 'hidden' : 'visible';
      }

      updateVisibility();

      observer = new MutationObserver(updateVisibility);
      observer.observe(cartCountElement, {
        childList: true,
        characterData: true,
        subtree: true
      });

      return true;
    }
    return false;
  }

  document.addEventListener('DOMContentLoaded', function() {
    if (!setupObserver()) {
      const watchObserver = new MutationObserver(function() {
        if (setupObserver()) {
          watchObserver.disconnect();
        }
      });

      watchObserver.observe(document.body, {
        childList: true,
        subtree: true
      });
    }
  });
  
  // Also try immediately in case DOM is already loaded
  if (document.readyState === 'loading') {
    // DOM not ready yet, our event listener will handle it
  } else {
    // DOM is already ready
    if (!setupObserver()) {
      // If not found, start watching
      const watchObserver = new MutationObserver(function() {
        if (setupObserver()) {
          watchObserver.disconnect();
        }
      });
      
      watchObserver.observe(document.body, {
        childList: true,
        subtree: true
      });
    }
  }
})();

// A11y / SEO / LCP optimization for Shopify video_tag auto-generated poster <img>:
//   1) Backfill alt if missing/empty
//   2) Set fetchpriority="high" on the first one (typically the LCP element)
(function() {
  var firstSeen = false;
  function fixPosterImgs() {
    var defaultAlt = (document.title || 'GunZee')
      .replace(/\s*[\|\-–—]\s*GunZee\s*$/i, '')
      .trim() || 'GunZee scenario training targets';
    var imgs = document.querySelectorAll('video-media video > img, video > img');
    imgs.forEach(function(img) {
      var current = img.getAttribute('alt');
      if (current === null || current.trim() === '') {
        img.setAttribute('alt', defaultAlt);
      }
      if (!firstSeen && !img.hasAttribute('fetchpriority')) {
        img.setAttribute('fetchpriority', 'high');
        firstSeen = true;
      }
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fixPosterImgs);
  } else {
    fixPosterImgs();
  }
  window.addEventListener('load', function() {
    setTimeout(fixPosterImgs, 250);
    setTimeout(fixPosterImgs, 1500);
  });
})();